/******************************************************************************
 *** MbrasReturnHistory ** 복직 상세내용
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import RadioBox from "@/js/common/ui/input/RadioBox";
import Util from "@/js/common/Util";
import React from "react";

import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";
import MemberFileView from "../FileBox/MemberFileView";

interface Props {
    mbrasId        : string;
    mbrasAtrzDocId : string;
}

const MbrasReturnHistory = ({ mbrasId, mbrasAtrzDocId }: Props) => {
    const [openLine, setOpenLine] = React.useState(false);

    const [returnYmd       , setReturnYmd       ] = React.useState(""); // 복직일자
    const [sbmsYmd         , setSbmsYmd         ] = React.useState(""); // 상신일자
    const [atrzYmd         , setAtrzYmd         ] = React.useState(""); // 승인일자
    const [rglrRegMm       , setRglrRegMm       ] = React.useState(""); // 등록월
    const [lbrShpSeCd      , setLbrShpSeCd      ] = React.useState(""); // 현재 근로형태
    const [chgLbrShpSeCd   , setChgLbrShpSeCd   ] = React.useState(""); // 변경 근로형태
    const [ocptTypeCd      , setOcptTypeCd      ] = React.useState(""); // 현재 직종
    const [chgOcptTypeCd   , setChgOcptTypeCd   ] = React.useState(""); // 변경 직종
    const [upOgnzCd        , setUpOgnzCd        ] = React.useState(""); // 현재 본부
    const [chgUpOgnzCd     , setChgUpOgnzCd     ] = React.useState(""); // 변경 본부
    const [ogdpOrgCd       , setOgdpOrgCd       ] = React.useState(""); // 현재 지부
    const [chgOgdpOrgCd    , setChgOgdpOrgCd    ] = React.useState(""); // 변경 지부
    const [wtjrNm          , setWtjrNm          ] = React.useState(""); // 현재 관내
    const [chgWtjrNm       , setChgWtjrNm       ] = React.useState(""); // 변경 관내
    const [addr            , setAddr            ] = React.useState(""); // 현재 주소
    const [chgAddr         , setChgAddr         ] = React.useState(""); // 변경 주소
    const [mbrasJoinSttsCd , setMbrasJoinSttsCd ] = React.useState(""); // 현재 조합원 상태
    const [chgJoinSttsCd   , setChgJoinSttsCd   ] = React.useState(""); // 변경 조합원 상태
    const [wthdAgreCd      , setWthdAgreCd      ] = React.useState(""); // 현재 원천징수 상태
    const [chgWthdAgreCd   , setChgWthdAgreCd   ] = React.useState(""); // 변경 원천징수 상태
    const [wthdAtchFileId  , setWthdAtchFileId  ] = React.useState(""); // 원천징수 첨부파일 ID
    const [wthdFileNm      , setWthdFileNm      ] = React.useState(""); // 원천징수 첨부파일명
    const [etcAtchFileId   , setEtcAtchFileId   ] = React.useState(""); // 기타 첨부파일 ID
    const [etcFileNm       , setEtcFileNm       ] = React.useState(""); // 기타 첨부파일명
    const [listLine        , setListLine        ] = React.useState<any[]>([]); // 결재라인

    // 변경 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId,
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc;
                const listItem = res.result.listItem;
                const listFile = res.result.listFile;
                const atrzLine = res.result.listLine;
                
                const lbrShpItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "01"); // 근로형태
                const ocptTypeItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "02"); // 직종
                const upOgnzItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "03"); // 본부
                const ogdpOrgItem    = listItem.find((item: any) => item.mbrasInfoChgSeCd === "04"); // 지부
                const wtjrItem       = listItem.find((item: any) => item.mbrasInfoChgSeCd === "05"); // 관내
                const addrItem       = listItem.find((item: any) => item.mbrasInfoChgSeCd === "06"); // 주소
                const joinSttsItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "07"); // 조합원 상태
                const wthdStatusItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "08"); // 원천징수 상태

                const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02"); // 원천징수 첨부파일
                const etcFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                setReturnYmd(mbrasDoc.applyDt);
                if (Util.isNotEmpty(mbrasDoc.atrzReqDt)) setSbmsYmd(mbrasDoc.atrzReqDt);
                if (Util.isNotEmpty(mbrasDoc.atrzDt)) setAtrzYmd(mbrasDoc.atrzDt);
                if (Util.isNotEmpty(mbrasDoc.regMm)) setRglrRegMm(mbrasDoc.regMm);

                setLbrShpSeCd(lbrShpItem.chgBefCn);
                setChgLbrShpSeCd(lbrShpItem.chgAfterCn);
                setOcptTypeCd(ocptTypeItem.chgBefCn);
                setChgOcptTypeCd(ocptTypeItem.chgAfterCn);
                setUpOgnzCd(upOgnzItem.chgBefCn);
                setChgUpOgnzCd(upOgnzItem.chgAfterCn);
                setOgdpOrgCd(ogdpOrgItem.chgBefCn);
                setChgOgdpOrgCd(ogdpOrgItem.chgAfterCn);
                setWtjrNm(wtjrItem.chgBefCn);
                setChgWtjrNm(wtjrItem.chgAfterCn);
                setAddr(addrItem.chgBefCn);
                setChgAddr(addrItem.chgAfterCn);
                setMbrasJoinSttsCd(joinSttsItem.chgBefCn);
                setChgJoinSttsCd(joinSttsItem.chgAfterCn);
                setWthdAgreCd(wthdStatusItem.chgBefCn);
                setChgWthdAgreCd(wthdStatusItem.chgAfterCn);

                if (Util.isNotEmpty(wthdFileInfo)) {
                    setWthdAtchFileId(wthdFileInfo.mbrasAtchFileId);
                    setWthdFileNm(wthdFileInfo.fileNm);
                }

                if (Util.isNotEmpty(etcFileInfo)) {
                    setEtcAtchFileId(etcFileInfo.mbrasAtchFileId);
                    setEtcFileNm(etcFileInfo.fileNm);
                }

                setListLine(atrzLine);

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId, mbrasId]);

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    return (
        <div className="w100p bsBdb p2 pb8">
            {/* 결재라인 */}
            <AtrzLineBox
                listLine={listLine}
                open={openLine}
                onToggle={() => setOpenLine((value) => !value)}
                showOrgInfo={true}
            />

            {/* 복직 신청/승인 정보 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    복직 신청/승인 정보
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h40 bgcFFF5ED bdb1 bdcDDDDDD">
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555">
                            복직일자
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            상신일자
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            승인일자
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            등록월
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="flx1 dpFlx aiC jcC fm-c fs14 fc222222">
                            {renderValue(Util.cvtDateStrForm(returnYmd, "-", "YYYYMMDD"))}
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(sbmsYmd, "-", "YYYYMMDD"))}
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtDateStrForm(atrzYmd, "-", "YYYYMMDD"))}
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.cvtMonthStrForm(rglrRegMm))}
                        </div>
                    </div>
                </div>
            </div>

            {/* 변경 신청 내역 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    변경 신청 내역
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    <div className="dpFlx h40 bgcFAFAFA bdb1 bdcDDDDDD">
                        <div className="w140 dpFlx aiC jcC fm-b fs13 fc555555">
                            구분
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            현재
                        </div>
                        <div className="flx1 dpFlx aiC jcC fm-b fs13 fc555555 bdl1 bdcDDDDDD">
                            변경
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            근로형태
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("LBR_SHP_SE_CD", lbrShpSeCd))}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("LBR_SHP_SE_CD", chgLbrShpSeCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            직종
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("OCPT_TYPE_CD", ocptTypeCd))}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getValToCode("OCPT_TYPE_CD", chgOcptTypeCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            본부
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getUpOrgName(upOgnzCd))}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getUpOrgName(chgUpOgnzCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            지부
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(Util.getDownOrgName(ogdpOrgCd))}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(Util.getDownOrgName(chgOgdpOrgCd))}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            관내
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(wtjrNm)}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(chgWtjrNm)}
                        </div>
                    </div>

                    <div className="dpFlx minH64 bdb1 bdcDDDDDD">
                        <div className="w140 minH64 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            주소
                        </div>
                        <div className="flx1 minH64 dpFlx aiC pl15 pr15 pt12 pb12 fm-c fs14 fc222222 lh20 bdl1 bdcDDDDDD">
                            {renderValue(addr)}
                        </div>
                        <div className="flx1 minH64 dpFlx aiC pl15 pr15 pt12 pb12 fm-c fs14 fc007bff lh20 bdl1 bdcDDDDDD">
                            {renderValue(chgAddr)}
                        </div>
                    </div>

                    <div className="dpFlx h42 bdb1 bdcDDDDDD">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            상태
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc222222 bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode("MBRAS_JOIN_STTS_CD", mbrasJoinSttsCd),
                            )}
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15 fm-c fs14 fc007bff bdl1 bdcDDDDDD">
                            {renderValue(
                                Util.getValToCode("MBRAS_JOIN_STTS_CD", chgJoinSttsCd),
                            )}
                        </div>
                    </div>

                    <div className="dpFlx h42">
                        <div className="w140 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563">
                            원천징수
                        </div>

                        <div className="flx1 h42 dpFlx aiC jcC bdl1 bdcDDDDDD">
                            <RadioBox
                                codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({ code: item.code, name: item.code === "W01" ? "동의" : "철회" }))}
                                value={wthdAgreCd}
                                btnColor="#555555"
                                btnSize={14}
                                btnClass=""
                                labelClass="ml6 fm-c fs13 fc333333"
                                interval={20}
                                disabled={true}
                            />
                        </div>

                        <div className="flx1 h42 dpFlx aiC jcC bdl1 bdcDDDDDD">
                            <RadioBox
                                codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({ code: item.code, name: item.code === "W01" ? "동의" : "철회" }))}
                                value={chgWthdAgreCd}
                                btnColor="#007BFF"
                                btnSize={14}
                                btnClass=""
                                labelClass="ml6 fm-c fs13 fc333333"
                                interval={20}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 첨부파일 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111827 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    첨부파일
                </div>

                <div className="bd1 bdcDDDDDD bdrd10 ofH bgcWhite">
                    {Util.isNotEmpty(chgWthdAgreCd) && wthdAgreCd !== chgWthdAgreCd && (
                        <div className="dpFlx h42 bdb1 bdcDDDDDD">
                            <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                원천징수 동의서
                            </div>
                            <div className="flx1 h42 dpFlx aiC pl15 pr15">
                                <MemberFileView
                                    mbrasId={mbrasId}
                                    mbrasAtchFileId={wthdAtchFileId}
                                    mbrFileNm={wthdFileNm}
                                />
                            </div>
                        </div>
                    )}

                    <div className="dpFlx h42">
                        <div className="w150 h42 dpFlx aiC jcC bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                            기타
                        </div>
                        <div className="flx1 h42 dpFlx aiC pl15 pr15">
                            <MemberFileView
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                mbrFileNm={etcFileNm}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MbrasReturnHistory;